<template>
	<section class="company-content stylized-container">
		<ActionSetNav
			class="company-content__secondary-nav-action"
			name="Jump to: "
			:display="true"
			:actions="secondaryNavActions"
		/>
		<div>
			<h3>Modules</h3>
		</div>
		<!-------- MODULES SECTION -------->
		<!-- UI/UX NOTE: feel free to use another component or propose a new one or to include a new variant on a already created component -->
		<ActionSetNav
			class="company-content__modules-nav-action"
			name=""
			:display="true"
			:actions="moduleNavActions"
		/>
		<Toggle
			v-model="expandAllSections"
			@change="handleExpandSections"
			label="Expand All Details"
			data-test="expandAllToggle"
		>
			<template slot="true-value">On</template>
			<template slot="false-value">Off</template>
		</Toggle>
		<!-------- ADDRESS SECTION -------->
		<CompanyAddress ref="companyAddress" :data="data.address" />
		<!-------- CONTACT INFORMATION SECTION -------->
		<CompanyInformation ref="companyInformation" :data="data.contactInfo" />
		<!-------- SHIPPING SECTION -------->
		<CompanyShipping ref="companyShipping" :data="data.shipping" />
		<!-------- OEMS SECTION -------->
		<CompanyOEMS ref="companyOEMS" :data="data.oems" />
		<!-------- COMPANY SETTINGS SECTION -------->
		<SectionContainer
			ref="companySettings"
			:isExpandable="true"
			title="Company Settings"
		>
			<template #content>
				<p>Applies to All Locations</p>
			</template>
		</SectionContainer>
		<!-------- ADVANCED SECTION -------->
		<CompanyAdvanced ref="companyAdvanced" :data="data.advanced" />
	</section>
</template>

<script>
import ActionSetNav from '@/site-components/actions-set/action-set-nav';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import SectionContainer from '@/components/shells/section-container/section-container';
import CompanyAddress from './sections/company-address.vue';
import CompanyInformation from './sections/company-information.vue';
import CompanyShipping from './sections/company-shipping.vue';
import CompanyOEMS from './sections/company-oems.vue';
import CompanyAdvanced from './sections/company-advanced.vue';

export default {
	name: 'CompanyContent',
	components: {
		ActionSetNav,
		Toggle,
		SectionContainer,
		CompanyAddress,
		CompanyInformation,
		CompanyShipping,
		CompanyOEMS,
		CompanyAdvanced
	},
	props: {
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			expandAllSections: true,
			secondaryNavActions: [
				{
					id: 1,
					action: {
						name: 'company-oems',
						path: '#oems'
					},
					title: 'Jump to OEMS',
					iconClass: '',
					label: 'OEMS',
					type: 'anchor',
					visible: true
				},
				{
					id: 2,
					action: {
						name: 'company-advance',
						path: '#advance'
					},
					title: 'Jump to Advance',
					iconClass: '',
					label: 'Advance',
					type: 'anchor',
					visible: true
				},
				{
					id: 3,
					action: {
						name: 'company-advance',
						path: '#advance'
					},
					title: 'Jump to Shipping',
					iconClass: '',
					label: 'Advance',
					type: 'anchor',
					visible: true
				}
			],
			moduleNavActions: [
				{
					id: 1,
					action: {
						name: 'accounting',
						path: '#Accounting'
					},
					title: 'Jump to Accounting',
					iconClass: '',
					label: 'Accounting',
					type: 'anchor',
					visible: true
				},
				{
					id: 2,
					action: {
						name: 'payroll',
						path: '#advance'
					},
					title: 'Jump to Payroll',
					iconClass: '',
					label: 'Pauroll',
					type: 'anchor',
					visible: true
				},
				{
					id: 3,
					action: {
						name: 'parts-locations',
						path: `/clients/${this.$route.params.id}/companies/${this.$route.params.companyCode}/parts-locations`,
						params: {
							company: this.data
						}
					},
					title: 'Jump to Parts',
					iconClass: '',
					label: 'Parts',
					type: 'router-link',
					visible: true
				},
				{
					id: 4,
					action: {
						name: 'sales',
						path: '#sales'
					},
					title: 'Jump to Sales',
					iconClass: '',
					label: 'Sales',
					type: 'anchor',
					visible: true
				},
				{
					id: 5,
					action: {
						name: 'service-locations',
						path: `/clients/${this.$route.params.id}/companies/${this.$route.params.companyCode}/service-locations`,
						params: {
							company: this.data
						}
					},
					title: 'Jump to Service',
					iconClass: '',
					label: 'Service',
					type: 'router-link',
					visible: true
				}
			]
		};
	},
	methods: {
		handleExpandSections(e) {
			this.$refs.companyAddress.$refs.sectionContainer.open = e;
			this.$refs.companyInformation.$refs.sectionContainer.open = e;
			this.$refs.companyShipping.$refs.sectionContainer.open = e;
			this.$refs.companyOEMS.$refs.sectionContainer.open = e;
			this.$refs.companySettings.open = e;
			this.$refs.companyAdvanced.$refs.sectionContainer.open = e;
		}
	}
};
</script>

<style lang="scss" scoped>
.company-content {
	&__secondary-nav-action {
		margin: 0 0 0 auto;
		max-width: 300px;

		&::v-deep .action-set-nav__name {
			max-width: calc(100% - 200px);
		}
	}

	&__modules-nav-action {
		max-width: auto;
		background: none;
		box-shadow: none;
	}
}

h5 {
	margin-block-start: 0;
	margin-block-end: 0;
}

.stylized-container {
	border: 1px solid gainsboro;
	border-radius: 4px;
	padding: $padding-md;
	background: $white;
}

// UI/UX NOTE: Just to test, make any change you need
.company-address ::v-deep .section-header__head {
	@include stickyTop;
}

.company-information ::v-deep .section-header__head {
	@include stickyTop;
}

.company-shipping ::v-deep .section-header__head {
	@include stickyTop;
}

.company-oems ::v-deep .section-header__head {
	@include stickyTop;
}

.company-advanced ::v-deep .section-header__head {
	@include stickyTop;
}
</style>
